import React from 'react';

const Spinner = () => (
  <g fill="none" fillRule="evenodd" stroke="#fff">
    <g transform="translate(1 1)" strokeWidth="2">
      <circle strokeOpacity=".5" cx="15" cy="15" r="15" />
      <path d="M30 15c0-9.94-8.06-15-15-15">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 15 15"
          to="360 15 15"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>
    </g>
  </g>
);

export default Spinner;
